import { Group, Text } from '@mantine/core';
import { ContentSectionContentDisplay } from './ContentSectionContentDisplay';
import {
    useContentSectionContentActions,
} from '../../../resource/resources/artifacts/content/contentSectionContentResource';

export const ContentSectionDisplay= ({ contentSectionId, showOnlyIfNotAvailable, showOnlyIfAvailable }: {
    contentSectionId: string;
    showOnlyIfNotAvailable?: boolean
    showOnlyIfAvailable?: boolean
}) => {
    const contentSectionContentActions = useContentSectionContentActions()

    const contentSectionContentsQuery = contentSectionContentActions.useGetAllResources(contentSectionId);

    const getWidthPercentage = (weight: number) => {
        const weightSum = contentSectionContentsQuery.data?.map(value => value.decorator.weight).reduce((partialSum, a) => partialSum + a, 0) ?? 1;
        const percentage = (weight / weightSum) * 100;
        return `${percentage}%`;
    };

    if (!contentSectionContentsQuery.data?.length) {
        if (showOnlyIfAvailable) {
            return <div></div>;
        }
        return <Text>No Section Content Available</Text>;
    } else if (showOnlyIfNotAvailable) {
        return <div></div>;
    }
    return (
        <Group w={"100%"} wrap={"nowrap"}>
            {contentSectionContentsQuery.data?.map((value) => (
                <div style={{ width: getWidthPercentage(value.decorator.weight) }} key={value.id}>
                    <ContentSectionContentDisplay contentSectionContentId={value.id} />
                </div>
            ))}
        </Group>
    );
};